import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

// cn — clsx для условных классов + tailwind-merge для разрешения конфликтов
// (`p-4` из примитива и `p-2` от потребителя → остаётся `p-2`). DESIGN.md R4.
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
